/* HfreeO basket. One box per order: choosing a pack replaces whatever is in the basket, because
   a parcel carries at most 24 cans (Business/FACTS.md, Consumer offer). Prices and the upgrade
   gap come from the variant table rendered by snippets/cart-drawer.liquid, never from code. */
(function () {
  var HF = (window.HF = window.HF || {});
  var drawer = document.getElementById('hf-drawer');
  var dataEl = document.getElementById('hf-variants');
  var variants = [];
  try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
  var byId = {};
  variants.forEach(function (v) { byId[v.id] = v; });
  var ladder = variants.slice().sort(function (a, b) { return a.cans - b.cans; });

  function money(pence) { return '£' + (pence / 100).toFixed(2); }
  function perCan(v) { return money(Math.round(v.price / v.cans)); }
  HF.money = money;

  function nextUp(v) {
    var i = ladder.indexOf(v);
    for (var j = i + 1; j < ladder.length; j++) if (ladder[j].available) return ladder[j];
    return null;
  }

  function json(url, body) {
    return fetch(url, {
      method: body === undefined ? 'GET' : 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function fetchCart() { return json('/cart.js'); }

  function setCount(n) {
    document.querySelectorAll('[data-hf-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function el(id) { return drawer ? drawer.querySelector('[data-hf="' + id + '"]') : null; }

  function render(cart) {
    setCount(cart.item_count);
    if (!drawer) return cart;
    var line = cart.items[0];
    var v = line ? byId[line.variant_id] : null;
    el('empty').hidden = !!line;
    el('filled').hidden = !line;
    if (!line) return cart;

    el('title').textContent = line.variant_title || line.product_title;
    el('percan').textContent = v ? v.cans + ' × 250ml cans · delivery included' : '';
    // The carton's own photo from the variant, as checkout shows it; the can stays if it has none.
    var thumb = el('thumb');
    if (thumb && line.image) {
      thumb.removeAttribute('srcset');
      thumb.src = line.image + (line.image.indexOf('?') < 0 ? '?' : '&') + 'width=180';
      thumb.parentNode.classList.add('is-photo');
    }
    el('price').textContent = money(line.final_line_price);
    el('subtotal').textContent = money(cart.total_price);
    el('checkout').textContent = 'Checkout';

    // A brake can land after a pack is already in the basket. So can a carton with no Shopify stock:
    // add.js refuses it at 422, but the form add, a cart permalink or stock closing after the add
    // get it in, and checkout then strips the line. Checkout is blocked for either.
    var offSale = !!(v && (v.braked || v.available === false));
    el('checkout').hidden = offSale;
    el('secure').hidden = offSale;
    el('braked').hidden = !offSale;
    // The batch 2 line is the brake's story; Shopify stock running out on one carton gets its own.
    var stockOnly = !!(offSale && !v.braked);
    var elsewhere = !!(v && ladder.some(function (x) { return x !== v && x.available; }));
    var brakeLine = el('braked-brake');
    var pickLine = el('braked-stock-pick');
    var noneLine = el('braked-stock-none');
    if (brakeLine) brakeLine.hidden = !(v && v.braked);
    if (pickLine) pickLine.hidden = !(stockOnly && elsewhere);
    if (noneLine) noneLine.hidden = !(stockOnly && !elsewhere);

    // The app line: six extra cans in the app, only for a carton whose variant has them.
    var extra = el('extra');
    if (extra) {
      extra.hidden = !(v && v.extra);
      if (v && v.extra) el('extra-text').textContent = extra.getAttribute('data-tpl').replace('{seeds}', v.extra);
    }

    var up = v ? nextUp(v) : null;
    var nudge = el('nudge');
    nudge.hidden = !up;
    // "Best value carton" only for the biggest carton on sale, never for one whose bigger sibling is sold out.
    var best = el('best');
    if (best) best.hidden = !!up || !v || offSale || ladder.some(function (x) { return x.cans > v.cans && !x.braked; });
    if (up) {
      var isTop = !nextUp(up);
      el('nudge-badge').hidden = !isTop;
      el('nudge-title').textContent = 'Make it the ' + up.title + ' for ' + money(up.price - v.price) + ' more';
      el('nudge-sub').textContent = up.cans + ' cans at ' + perCan(up) + ' a can.';
      el('nudge-btn').textContent = 'Switch to ' + up.cans;
      el('nudge-btn').dataset.variant = up.id;
    }
    return cart;
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hf-drawer-open');
    var close = drawer.querySelector('[data-hf-close]');
    if (close) close.focus();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hf-drawer-open');
  }
  HF.openCart = function () { return fetchCart().then(render).then(open); };

  /* Copies the visit's first touch (snippets/first-touch.liquid) onto the cart as hidden
     attributes, so the order carries its source into Shopify's note_attributes and from there
     into shopify_orders. Without it a website order says nothing about where the buyer came from.
     A failure here must never cost the basket, so it resolves either way. */
  function stampFirstTouch() {
    var ft = typeof window.hfFirstTouch === 'function' ? window.hfFirstTouch() : {};
    var attributes = {};
    Object.keys(ft).forEach(function (key) { if (ft[key] !== '' && ft[key] != null) attributes['_ft_' + key] = String(ft[key]); });
    /* PostHog only exists once the visitor has allowed analytics, so _ph_id is itself the consent:
       handle-shopify-webhook sends order_paid under it, and without it the order goes in anonymous. */
    if (window.posthog && window.posthog.__loaded) attributes._ph_id = String(window.posthog.get_distinct_id());
    if (!Object.keys(attributes).length) return Promise.resolve();
    return json('/cart/update.js', { attributes: attributes }).catch(function () {});
  }
  /* An add can beat the consent answer (a cart email's restore link runs on load, a new visitor
     can add before the banner), so the touch lands after the basket is filled. Stamp it then, but
     only a basket this page filled: update.js merges keys, so stamping a basket left from an
     earlier visit would mix that visit's touch with this one. filled is set once add.js answers,
     so this does not run beside the restore's own clear and add. */
  var filled = false;
  document.addEventListener('hf:first-touch', function () {
    if (!filled) return;
    fetchCart().then(function (cart) { if (cart.item_count > 0) return stampFirstTouch(); }).catch(function () {});
  });

  /* Klaviyo's Added to Cart, which starts the cart abandon flow, in Klaviyo's standard shape plus
     `carton`, the variant's name. Prices are pounds as plain numbers. There is no CheckoutURL,
     because the basket lives in this browser's cookie; RestoreURL rebuilds it in any browser
     through ?carton=<variant>&add=1 below. The same link also goes on the profile as
     cart_restore_url, which Cart E1's button reads: the flow takes only the first add, so a visitor
     who switched cartons would otherwise get the old one back. klaviyo.js comes from the Klaviyo
     app embed; until it loads, each call waits in _klOnsite, its documented queue. Klaviyo keeps
     the event only for a visitor it has identified. */
  function trackAdded(variantId, cart) {
    var added = cart.items.filter(function (i) { return i.variant_id === Number(variantId); })[0];
    if (!added) return cart;
    var pounds = function (pence) { return pence / 100; };
    var url = function (path) { return location.origin + path; };
    var event = ['track', 'Added to Cart', {
      $value: pounds(cart.total_price),
      AddedItemProductName: added.title,
      AddedItemProductID: added.product_id,
      AddedItemVariantID: added.variant_id,
      AddedItemSKU: added.sku,
      AddedItemImageURL: added.image,
      AddedItemURL: url(added.url),
      AddedItemPrice: pounds(added.final_price),
      AddedItemQuantity: added.quantity,
      ItemNames: cart.items.map(function (i) { return i.title; }),
      Items: cart.items.map(function (i) {
        return {
          ProductID: i.product_id, VariantID: i.variant_id, SKU: i.sku, ProductName: i.title, Quantity: i.quantity,
          ItemPrice: pounds(i.final_price), RowTotal: pounds(i.final_line_price),
          ProductURL: url(i.url), ImageURL: i.image
        };
      }),
      carton: added.variant_title,
      RestoreURL: url('/pages/get-cans?carton=' + added.variant_id + '&add=1')
    }];
    var restore = ['identify', { cart_restore_url: event[2].RestoreURL }];
    var q = window.klaviyo && window.klaviyo.push ? window.klaviyo : (window._klOnsite = window._klOnsite || []);
    q.push(restore);
    q.push(event);
    return cart;
  }

  // quiet: a restore from the cart emails' link, which is not a new add, so nothing is tracked.
  HF.setBox = function (variantId, button, quiet) {
    var label = button ? button.innerHTML : null;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    return json('/cart/clear.js', {})
      .then(function () {
        // Pre-order: the carton carries when it ships (snippets/cart-drawer.liquid renders #hf-preorder).
        var item = { id: Number(variantId), quantity: 1 };
        var pre = document.getElementById('hf-preorder');
        if (pre) { var p = JSON.parse(pre.textContent); item.properties = {}; item.properties[p.name] = p.value; }
        return json('/cart/add.js', { items: [item] }).then(function () { filled = true; });
      })
      .then(stampFirstTouch)
      .then(fetchCart)
      .then(function (cart) { return quiet ? cart : trackAdded(variantId, cart); })
      .then(render)
      .then(open)
      .catch(function () { if (button) label = 'Sold out. Try another carton'; })
      // render() relabels the drawer's own nudge button, so only a label still reading "Adding…" goes back.
      .then(function () { if (button) { button.disabled = false; if (button.textContent === 'Adding…') button.innerHTML = label; } });
  };

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-hf-add]');
    if (add) { e.preventDefault(); HF.setBox(add.dataset.variant || add.dataset.hfAdd, add); return; }
    if (e.target.closest('[data-hf-open-cart]')) { e.preventDefault(); HF.openCart(); return; }
    if (e.target.closest('[data-hf-close]')) { close(); return; }
    if (e.target.closest('[data-hf-remove]')) { json('/cart/clear.js', {}).then(fetchCart).then(render); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
  });
  /* The cart emails' links. RestoreURL, ?carton=<variant>&add=1, puts that carton back in the
     basket through HF.setBox, so the pre-order line and the first touch go on as on any add, and
     opens it; ?cart=open opens whatever this browser's basket holds. Neither runs without the
     drawer, which only renders once the site is selling. */
  var restore = location.search.match(/[?&]carton=(\d+)&add=1(&|$)/);
  if (drawer && restore) {
    // Off the address bar, so a reload or a shared link never clears and refills the basket again.
    history.replaceState(null, '', location.pathname + location.search.replace(/([?&])carton=\d+&add=1(&|$)/, '$1').replace(/[?&]$/, '') + location.hash);
    HF.setBox(restore[1], null, true);
  } else if (/[?&]cart=open(&|$)/.test(location.search)) HF.openCart();

  /* The carton cards (snippets/hf-carton-cards.liquid). A pick fills the element's button, the
     line under it and the nudge to the next carton up, all from words and figures Liquid wrote
     onto the radios, then tells the page with an hf:carton event so every other set of cards (the
     Shop buy box, the bottom sheet), the Shop price line and the sticky bar follow the same pick.
     ?carton=starter picks the Starter Carton. Nothing on the site links it since the site moved to
     push the bigger cartons (Josh, 9 Oct 2026); it stays for any link from outside. */
  function fillCarton(tpl, d) {
    var map = { price: d.price, per_can: d.per, n: d.cans, carton_name: d.title, seeds: d.extra };
    return (tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  if (window.customElements && !customElements.get('hf-carton-cards')) {
    customElements.define('hf-carton-cards', class extends HTMLElement {
      connectedCallback() {
        if (this.radios) return;
        var self = this;
        this.radios = [].slice.call(this.querySelectorAll('input[data-hf-pack]'));
        if (!this.radios.length) return;
        this.cta = this.querySelector('[data-hf-cc-cta]');
        this.note = this.querySelector('[data-hf-cc-note]');
        this.extra = this.querySelector('[data-hf-cc-extra]');
        this.nudge = this.querySelector('[data-hf-cc-nudge]');
        this.toUp = this.querySelector('[data-hf-cc-switch]');

        this.addEventListener('change', function (e) {
          if (self.radios.indexOf(e.target) < 0 || !e.target.checked) return;
          self.show(e.target, true);
        });
        if (this.toUp) this.toUp.addEventListener('click', function () {
          var to = self.find(self.toUp.getAttribute('data-to'));
          if (!to || to.disabled) return;
          to.checked = true;
          self.show(to, true);
          to.focus();
        });
        document.addEventListener('hf:carton', function (e) {
          if (e.detail.from === self) return;
          var r = self.find(e.detail.variant);
          if (!r) return;
          r.checked = true;
          self.show(r, false);
        });
        window.addEventListener('pageshow', function (e) { if (e.persisted && self.current()) self.show(self.current(), false); });

        var start = this.current();
        if (/[?&]carton=starter(&|$)/.test(location.search)) {
          var starter = this.radios.filter(function (r) { return r.dataset.role === 'starter' && !r.disabled; })[0];
          if (starter) { starter.checked = true; start = starter; }
        }
        // A reload can restore a different radio than the one Liquid checked, so say which it is.
        if (start) this.show(start, true);
      }
      find(id) { return this.radios.filter(function (r) { return r.value === String(id); })[0] || null; }
      current() { return this.radios.filter(function (r) { return r.checked; })[0] || null; }
      show(r, announce) {
        var d = r.dataset;
        if (this.cta && !this.cta.disabled) {
          this.cta.setAttribute('data-variant', d.variant);
          this.cta.textContent = fillCarton(this.cta.getAttribute('data-tpl'), d);
        }
        if (this.note) this.note.textContent = fillCarton(this.note.getAttribute('data-tpl'), d);
        // Six extra cans in the app, only under a carton whose variant has them (data-extra).
        if (this.extra) {
          this.extra.hidden = !d.extra;
          var words = this.extra.querySelector('[data-hf-cc-extra-text]');
          if (d.extra) words.textContent = fillCarton(words.getAttribute('data-tpl'), d);
        }
        if (this.nudge) {
          var up = d.up ? this.find(d.up) : null;
          var on = !!(up && !up.disabled);
          this.nudge.hidden = !on;
          if (on) {
            this.nudge.querySelector('[data-hf-cc-nudge-title]').textContent = d.upTitle;
            this.nudge.querySelector('[data-hf-cc-nudge-body]').textContent = d.upBody;
            this.toUp.textContent = d.upButton;
            this.toUp.setAttribute('data-to', d.up);
          }
        }
        if (announce) {
          document.dispatchEvent(new CustomEvent('hf:carton', {
            detail: { variant: d.variant, title: d.title, price: d.price, per: d.per, cans: d.cans, from: this }
          }));
        }
      }
    });
  }
})();
